import { AfterContentInit, Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormControl, ValidatorFn, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { EImportance } from 'src/app/domain/MGCE/enum/importance';
import { ETypeSubstrat } from 'src/app/domain/MGCE/enum/type-substrat';
import { EZone } from 'src/app/domain/MGCE/enum/zone';
import { MGCEProcess } from 'src/app/domain/MGCE/MGCE-Process';
import { Substrat } from 'src/app/domain/MGCE/substrat';
import { EInterventionType } from 'src/app/domain/planning/enum/intervention-type';
import { Prelevement } from 'src/app/domain/Shared/prelevement';
import { ENavigationRoute } from 'src/app/models/enum/navigation-route';
import { ENavigationErrorType } from 'src/app/models/navigation-error-type';
import { SpeedDialFabModel } from 'src/app/models/speed-dial-fab.model';
import { MGCEService } from 'src/app/services/mgce.service';
import { CoreData } from 'src/app/tools/core-data';
import { NotificationManager } from 'src/app/tools/notification-manager';
import { MGCESubstratBoxComponent } from 'src/app/tools/ui/mgce-substrat-box/mgce-substrat-box.component';
import { PrelevementDialogComponent } from 'src/app/tools/ui/prelevement-dialog/prelevement-dialog.component';
import { PrelevementDialogModel } from 'src/app/tools/ui/prelevement-dialog/prelevement-dialog.model';
import { StringConverter } from 'src/app/tools/ui/string-converter';
import *  as _ from 'lodash';
import { LargeurStation } from 'src/app/domain/MGCE/largeur-station';
import { MPCEMGCEMeasureBoxComponent } from 'src/app/tools/ui/mpce-mgce-measure-box/mpce-mgce-measure-box.component';
import { TransectMesure } from 'src/app/domain/MGCE/transect-mesure';
import { Transect } from 'src/app/domain/MGCE/transect';
import { TransectMeasureBoxComponent } from 'src/app/tools/ui/transect-mesure-box/transect-measure-box.component';
import { EModeMesure } from 'src/app/domain/Shared/enum/mode-mesure';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { ChangeNavigationService } from 'src/app/tools/change-navigation-service';

@Component({
    selector: 'app-mgce',
    templateUrl: './mgce.component.html',
    styleUrls: ['./mgce.component.scss']
})
export class MGCEComponent implements OnInit, AfterContentInit {
    private MESURE_MAX = 10;
    public FabOptions: SpeedDialFabModel[] =
        [
            {
                Id: 0,
                Text: undefined,
                Icon: 'save'
            },
        ];
    public ZoneList: string[] =
        Object.values(EZone)
            .filter(x => !isNaN(Number(x)))
            .map((x: EZone) => StringConverter.getZoneName(x));

    public ImportanceList: string[] =
        Object.values(EImportance)
            .filter(x => !isNaN(Number(x)))
            .map((x: EImportance) => StringConverter.getImportanceName(x));

    public ModeMesureList: string[] =
        Object.values(EModeMesure)
            .filter(x => !isNaN(Number(x)))
            .map((x: EModeMesure) => StringConverter.getModeMesureName(x));

    public COMMENT_MAX_SIZE = 100;
    IsAmontX2FarControl = new UntypedFormControl('', Validators.compose([
        this.checkXAgainstAval(),
        Validators.pattern(/^(\d{6})?$/)]));
    IsAvalX2FarControl = new UntypedFormControl('', Validators.compose([
        this.checkXAgainstAmont(),
        Validators.pattern(/^(\d{6})?$/)]));

    IsAmontY2FarControl = new UntypedFormControl('', Validators.compose([
        this.checkYAgainstAval(),
        Validators.pattern(/^(\d{7})?$/)]));
    IsAvalY2FarControl = new UntypedFormControl('', Validators.compose([
        this.checkYAgainstAmont(),
        Validators.pattern(/^(\d{7})?$/)]));

    ValidAmontMaxLength = new UntypedFormControl('', [Validators.maxLength(this.COMMENT_MAX_SIZE)]);
    ValidAvalMaxLength = new UntypedFormControl('', [Validators.maxLength(this.COMMENT_MAX_SIZE)]);

    public MGCEProcess: MGCEProcess = new MGCEProcess();
    private interventionType: EInterventionType;
    private SubstratLastIndex = 1;

    constructor(
        private ChangeNavigationService: ChangeNavigationService,
        public coreData: CoreData,
        private snackBar: MatSnackBar,
        private mgceService: MGCEService,
        private router: Router,
        private dialog: MatDialog,
        private route: ActivatedRoute) {
        this.ChangeNavigationService.NavigationUsedEmitter.subscribe(x => {
            if (x) {
                // this.save(true);
            }
        })
    }

    ngOnInit() {
        if (!this.route.snapshot.params.processCode) {
            this.router.navigate([ENavigationRoute.Error, { type: ENavigationErrorType.URL }]);
            return;
        }

        this.interventionType = Number(this.route.snapshot.params.type) as EInterventionType;
        this.MGCEProcess.Code = this.route.snapshot.params.processCode;
    }

    ngAfterContentInit(): void {
        if (this.coreData.IsOffline) {
            this.MGCEProcess = this.coreData.getOfflineProcess(this.route.snapshot.params.processCode) as MGCEProcess;
            this.setIndex();
        } else {
            this.mgceService.getProcessByCode(this.MGCEProcess.Code).subscribe(x => {
                this.MGCEProcess = x;
                this.setIndex();
            });
        }

        this.ValidAmontMaxLength.markAsTouched();
        this.ValidAvalMaxLength.markAsTouched();
        this.IsAmontX2FarControl.markAsTouched();
        this.IsAvalX2FarControl.markAsTouched();
        this.IsAmontY2FarControl.markAsTouched();
        this.IsAvalY2FarControl.markAsTouched();
    }

    onAmontXKeyUpEvent($event) {
        this.IsAvalX2FarControl.updateValueAndValidity();
    }
    onAvalXKeyUpEvent($event) {
        this.IsAmontX2FarControl.updateValueAndValidity();
    }
    onAmontYKeyUpEvent($event) {
        this.IsAvalY2FarControl.updateValueAndValidity();
    }
    onAvalYKeyUpEvent($event) {
        this.IsAmontY2FarControl.updateValueAndValidity();
    }

    checkXAgainstAmont(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null =>
            this.MGCEProcess && this.MGCEProcess.LocalisationStation &&
                !(Math.abs(control.value - this.IsAmontX2FarControl.value) > 500)
                ? null : { wrongColor: control.value };
    }

    checkXAgainstAval(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null =>
            this.MGCEProcess && this.MGCEProcess.LocalisationStation &&
                !(Math.abs(control.value - this.IsAvalX2FarControl.value) > 500)
                ? null : { wrongColor: control.value };
    }

    checkYAgainstAmont(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null =>
            this.MGCEProcess && this.MGCEProcess.LocalisationStation &&
                !(Math.abs(control.value - this.IsAmontY2FarControl.value) > 500)
                ? null : { wrongColor: control.value };
    }

    checkYAgainstAval(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null =>
            this.MGCEProcess && this.MGCEProcess.LocalisationStation &&
                !(Math.abs(control.value - this.IsAvalY2FarControl.value) > 500)
                ? null : { wrongColor: control.value };
    }

    public getZoneName(z: EZone) {
        return StringConverter.getZoneName(z);
    }

    public getImportanceName(i: EImportance) {
        return StringConverter.getImportanceName(i);
    }

    public getSubstratName(s: ETypeSubstrat) {
        return StringConverter.getMGCETypeSubstratName(s);
    }

    openMGCESubstratDialog(sub?: Substrat) {
        const dialogRef = this.dialog.open(MGCESubstratBoxComponent, {
            data: { sub },
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: Substrat) => {
            if (result) {
                result.Index = this.SubstratLastIndex++;
                this.MGCEProcess.MGCESubstratList.push(result);
                console.log(result.Index)
            }
        });
    }

    setIndex() {
        this.MGCEProcess.MGCESubstratList.forEach(x => {
            x.Index = this.SubstratLastIndex++;
        });
    }

    clearAndReOrderNumPrel(sub: Substrat) {
        this.MGCEProcess.MGCESubstratList.filter(y => y.Zone === sub.Zone).forEach(x => {
            if (x.Prelevement)
                x.Prelevement.Numero = undefined
        });

        this.MGCEProcess.MGCESubstratList.filter(y => y.Zone === sub.Zone).forEach(x => {
            if (x.Prelevement)
                x.Prelevement.Numero = this.getNextNumero(x)
        });
    }

    deleteSubstrat(sub: Substrat) {
        _.remove(this.MGCEProcess.MGCESubstratList, x => x.Index === sub.Index);
        this.SubstratLastIndex = 1;
        this.setIndex();

        this.clearAndReOrderNumPrel(sub);
    }

    openPrelevementDialog(sub: Substrat) {
        if (this.MGCEProcess.MGCESubstratList.filter(x => x.Prelevement &&
            (sub.Zone === EZone.IntermediaireAccessible || sub.Zone === EZone.IntermediaireNonAccessible ?
                x.Zone === EZone.IntermediaireAccessible || x.Zone === EZone.IntermediaireNonAccessible
                :
                x.Zone === sub.Zone)).length === 4) {

            NotificationManager.handleWarning(`Maximum atteint pour cette zone`, this.snackBar);
            return;
        }

        const prelevementDialogModel = new PrelevementDialogModel();
        prelevementDialogModel.Prelevement = sub.Prelevement ? sub.Prelevement : new Prelevement();
        prelevementDialogModel.Prelevement.Numero = prelevementDialogModel.Prelevement.Numero ?? this.getNextNumero(sub);
        prelevementDialogModel.IsCreation = sub.Prelevement ? false : true;
        prelevementDialogModel.IsForMGCE = true;

        const dialogRef = this.dialog.open(PrelevementDialogComponent, { width: '400px', data: prelevementDialogModel });
        dialogRef.afterClosed().subscribe((result: Prelevement) => {
            if (result) {
                sub.Prelevement = result;
                this.MGCEProcess.MGCESubstratList = _.orderBy(this.MGCEProcess.MGCESubstratList, x => x.Prelevement.Numero);
            }
        });
    }

    getNextNumero(sub: Substrat) {
        let numList
        switch (sub.Zone) {
            case EZone.Berge:
                numList = this.MGCEProcess.MGCESubstratList.filter(x => x?.Prelevement?.Numero && [1, 2, 3, 4].includes(x?.Prelevement?.Numero)).map(y => y.Prelevement.Numero) ?? []
                return numList.length > 0 ? Math.max(...numList) + 1 : 1
            case EZone.Profonde:
                numList = this.MGCEProcess.MGCESubstratList.filter(x => x?.Prelevement?.Numero && [5, 6, 7, 8].includes(x?.Prelevement?.Numero)).map(y => y.Prelevement.Numero) ?? []
                return numList.length > 0 ? Math.max(...numList) + 1 : 5
            case EZone.IntermediaireAccessible:
            case EZone.IntermediaireNonAccessible:
                numList = this.MGCEProcess.MGCESubstratList.filter(x => x?.Prelevement?.Numero && [9, 10, 11, 12].includes(x?.Prelevement?.Numero)).map(y => y.Prelevement.Numero) ?? []
                return numList.length > 0 ? Math.max(...numList) + 1 : 9
            default:
                return -1;
        }
    }

    getLpB(i) {
        return `Lpb ${i + 1}`;
    }

    getLm(i) {
        return `Lm ${i + 1}`;
    }

    computeLpBMoy() {
        if (this.MGCEProcess.MGCEMesureStation.LargeurStations.filter(y => y.LpB > 0).length === 0) {
            return 0;
        }
        return _.sum(this.MGCEProcess.MGCEMesureStation.LargeurStations.map(x => x.LpB)) / this.MGCEProcess.MGCEMesureStation.LargeurStations.filter(y => y.LpB > 0).length;
    }

    computeLtCalculee() {
        if (this.computeLpBMoy() < 8) {
            return this.computeLpBMoy() * 18;
        } else if (this.computeLpBMoy() >= 8 && this.computeLpBMoy() < 25) {
            return this.computeLpBMoy() * 12;
        } else {
            return this.computeLpBMoy() * 6;
        }
    }

    computeLmMoy() {
        if (this.MGCEProcess.MGCEMesureStation.LargeurStations.filter(y => y.LpB > 0).length === 0) {
            return 0;
        }
        return _.sum(this.MGCEProcess.MGCEMesureStation.LargeurStations.map(x => x.Lm)) / this.MGCEProcess.MGCEMesureStation.LargeurStations.filter(y => y.LpB > 0).length;
    }

    computeSmouille() {
        return this.MGCEProcess.MGCEMesureStation.LtReelle * this.computeLmMoy();
    }

    computeSmaxMarg() {
        return this.computeSmouille() * 5 / 100;
    }

    computePLimitZiZp() {
        return this.computePmax() * 0.7;
    }

    computeLmaxZB() {
        return this.computeLmMoy() * 0.05;
    }

    computePmax() {
        return _.max(_.flatMap(this.MGCEProcess.MGCETransectList.map(x => x.TransectMesureList.map(x => x.Profondeur))))
    }

    computePMaxByTransect(transect: Transect) {
        return _.max(transect.TransectMesureList.map(x => x.Profondeur));
    }

    computePLimitZiZpByTransect(transect: Transect) {
        return this.computePMaxByTransect(transect) * 0.7;
    }

    computeLmByTransect(transect: Transect) {
        return transect.Lm * 0.05;
    }

    removeLargeur(measure: LargeurStation) {
        // if (this.model.MesureStation.LargeurStations.length > 1) {
        //   this.model.MesureStation.LargeurStations.pop();
        // }
        _.remove(this.MGCEProcess.MGCEMesureStation.LargeurStations, x => x === measure);
    }

    openMesureBox(largueur?: LargeurStation) {
        if (this.MGCEProcess.MGCEMesureStation.LargeurStations.length >= this.MESURE_MAX) {
            NotificationManager.handleWarning(`Le nombre maximal de mesure est de ${this.MESURE_MAX}`, this.snackBar);
            return;
        }

        const dialogRef = this.dialog.open(MPCEMGCEMeasureBoxComponent, {
            data: {
                mesure: Object.assign({}, largueur) ?? new LargeurStation(),
                type: EInterventionType.MGCE
            },
            width: '333px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: LargeurStation) => {
            if (result) {
                if (!largueur) {
                    this.MGCEProcess.MGCEMesureStation.LargeurStations.push(result);
                } else {
                    Object.assign(largueur, result);
                }
            }
        });
    }

    CanAddTransect() {
        return this.MGCEProcess.MGCETransectList.length < 5;
    }

    addTransect() {
        this.MGCEProcess.MGCETransectList.push(new Transect());
    }

    removeTransectMesure(transect: Transect, measure: TransectMesure) {
        // if (this.model.MesureStation.LargeurStations.length > 1) {
        //   this.model.MesureStation.LargeurStations.pop();
        // }
        _.remove(transect.TransectMesureList, x => x === measure);
        this.updateDistanceAuBerger(transect)
    }

    openTransectMesureBox(transect: Transect, tm?: TransectMesure) {
        console.log('open ' + transect.TransectMesureList)
        const dialogRef = this.dialog.open(TransectMeasureBoxComponent, {
            data: Object.assign([], transect.TransectMesureList),
            width: '666px',
            maxHeight: '800px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: TransectMesure[]) => {
            if (result) {
                // if (!tm) {
                //     transect.TransectMesureList.push(result);
                // } else {
                //     Object.assign(tm, result);
                // }
                console.log('result ' + result)
                transect.TransectMesureList = result.filter(x => x.DistanceRive !== undefined && x.DistanceRive !== undefined)

                this.updateDistanceAuBerger(transect)
            }
        });
    }

    updateDistanceAuBerger(transect) {
        transect.DistanceRGZBZI = this.getDistanceRGZBZI(transect)
        transect.DistanceRGZIAZINA = this.getDistanceRGZIAZINA(transect)
        transect.DistanceRGZIZP = this.getDistanceRGZIZP(transect)

        transect.DistanceRDZBZI = this.getDistanceRDZBZI(transect)
        transect.DistanceRDZIAZINA = this.getDistanceRDZIAZINA(transect)
        transect.DistanceRDZIZP = this.getDistanceRDZIZP(transect)
    }

    getDistanceRGZBZI(transect: Transect) {
        let orderedList = _.orderBy(transect.TransectMesureList, x => x.DistanceRive)
        let candidat = null;
        for (let i = 0; i < orderedList.length; i++) {

            if (orderedList[i].Profondeur <= 100 && orderedList[i].DistanceRive <= transect.Lm * 0.05) {
                candidat = orderedList[i]
            }
            // if (i > 0 && orderedList[j - 1].DistanceRive < transect.Lm * 0.05)
            //     return orderedList[j - 1].DistanceRive
            // }
        }
        return candidat.DistanceRive;
    }

    getDistanceRGZIAZINA(transect: Transect) {
        let orderedList = _.orderBy(transect.TransectMesureList, x => x.DistanceRive)
        for (let i = 0; i < orderedList.length; i++) {

            if (orderedList[i].Profondeur > 100) {
                if (i > 0)
                    return orderedList[i - 1].DistanceRive
            }
        }
    }

    getDistanceRGZIZP(transect: Transect) {
        let orderedList = _.orderBy(transect.TransectMesureList, x => x.DistanceRive)
        for (let i = 0; i < orderedList.length; i++) {

            if (orderedList[i].Profondeur > this.computePLimitZiZp()) {
                if (i > 0)
                    return orderedList[i - 1].DistanceRive
            }
        }
    }

    getDistanceRDZBZI(transect: Transect) {
        let orderedList = _.orderBy(transect.TransectMesureList, x => x.DistanceRive, 'desc')
        // for (let i = 0; i < orderedList.length; i++) {

        //     if (orderedList[i].Profondeur > 100) {
        //         if (i > 0 && orderedList[i - 1].DistanceRive < transect.Lm * 0.05)
        //             return orderedList[i - 1].DistanceRive
        //     }
        // }

        let candidat = null;
        for (let i = 0; i < orderedList.length; i++) {

            if (orderedList[i].Profondeur <= 100 && (transect.Lm - orderedList[i].DistanceRive) <= transect.Lm * 0.05) {
                candidat = orderedList[i]
            }
        }
        if (candidat)
            return transect.Lm - candidat.DistanceRive;

    }

    getDistanceRDZIAZINA(transect: Transect) {
        let orderedList = _.orderBy(transect.TransectMesureList, x => x.DistanceRive, 'desc')
        for (let i = 0; i < orderedList.length; i++) {

            if (orderedList[i].Profondeur > 100) {
                if (i > 0)
                    return transect.Lm - orderedList[i - 1].DistanceRive
            }
        }
    }

    getDistanceRDZIZP(transect: Transect) {
        let orderedList = _.orderBy(transect.TransectMesureList, x => x.DistanceRive, 'desc')
        for (let i = 0; i < orderedList.length; i++) {

            if (orderedList[i].Profondeur > this.computePLimitZiZp()) {
                if (i > 0)
                    return transect.Lm - orderedList[i - 1].DistanceRive
            }
        }
    }

    CanSave() {
        return true;
    }

    save(forced: boolean) {
        if (!this.CanSave() && !forced) {
            NotificationManager.handleError('Les données ne sont pas valides', this.snackBar);
            return;
        }
        if (this.coreData.IsOffline) {
            this.coreData.setOfflineProcess(this.MGCEProcess);
        } else {
            this.mgceService.updateProcess(this.MGCEProcess).subscribe(x => {
                NotificationManager.handleSuccess('Intervention enregistrée', this.snackBar);
            });
        }
    }

    dispatch(event: SpeedDialFabModel) {

        switch (event.Id) {
            case 0:
                this.save(false);
                break;
        }
    }
}
